import { lazy } from "react";

// project-imports
import Loadable from "components/Loadable";

/**
 * Lazy-loaded component for rendering the list of Products.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} ListProductPage - Lazy-loaded ListProductPage component.
 */
const ListProductPage = Loadable(lazy(() => import("./ListProductPage")));

/**
 * Lazy-loaded component for rendering the add Product page.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} AddProductPage - Lazy-loaded AddProductPage component.
 */
const AddProductPage = Loadable(lazy(() => import("./AddProductPage")));

/**
 * Lazy-loaded component for rendering the View Product page.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} ViewProductPage - Lazy-loaded ViewProductPage component.
 */
const ViewProductPage = Loadable(lazy(() => import("./ViewProductPage")));

/**
 * Lazy-loaded component for rendering the View Product page.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} ViewProductPage - Lazy-loaded ViewProductPage component.
 */
const EditProductPage = Loadable(lazy(() => import("./EditProductPage")));

/**
 * Array containing route definitions for the Product-related pages.
 * @constant {Object[]} ProductRoutes - Array of Product route objects.
 * @property {string} ProductRoutes[].path - The path of the Product route.
 * @property {React.ReactElement} ProductRoutes[].element - The React element to be rendered for the Product route.
 */
const ProductRoutes = [
  {
    path: "list",
    element: <ListProductPage />,
  },
  {
    path: "add",
    element: <AddProductPage />,
  },
  {
    path: "view/:product_id",
    element: <ViewProductPage />,
  },
  {
    path: "edit/:product_id",
    element: <EditProductPage />,
  },
];

export default ProductRoutes;
